import React, { PureComponent } from 'react'
import cx from 'classnames'
import TextField from '../../../atoms/TextField/TextField'
import SearchIcon from '../../../atoms/Svgs/SearchOff'
import CloseIcon from '../../../atoms/Svgs/Close'
import styles from './SearchField.module.scss'
import TextInput from 'views/components/atoms/TextField/TextInput'
import { TextFieldTypes } from 'views/components/atoms/TextField/text-field.types'

interface ISearchFieldProps {
  query: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  setRef: (ref: HTMLInputElement | null) => void
}

const SearchField = ({ query, onChange, isOpen, onOpen, onClose, setRef }: ISearchFieldProps): React.ReactElement => {
  const classes = cx(styles.root, {
    [styles['is-open']]: isOpen,
  })

  const toggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    ;(isOpen ? onClose : onOpen)()
  }

  return (
    <div className={classes}>
      <TextField
        inputComponent={
          <TextInput
            type={TextFieldTypes.text}
            name="search"
            placeholder="Search..."
            onChange={onChange}
            value={query}
            ref={setRef}
          />
        }
      />
      <button type="button" className={styles['open-button']} onClick={toggle}>
        {isOpen ? <CloseIcon /> : <SearchIcon />}
      </button>
    </div>
  )
}

export default SearchField
